import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

export interface WizardSetting {
    stepSubTitle: string;
    backButtonText?: string;
    nextButtonText: string;
    nextButtonQaId?: string;
    nextButton2Text: string;
    isNextButton2Visible: boolean;
}

@Component({
    selector: 'nova-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss']
})
export class WizardComponent {
    @Input() showWizardStepper = false;
    @Input() title: string;
    @Input() toolbarTemplate: TemplateRef<any>;
    @Input() repipelineHeaderPreText: string;
    @Input() repipelinedDisplayedContract: string;
    @Input() isRepipelineHeaderBannerAvailable: boolean;
    @Input() stepIndex = 1;
    @Input() lastStepIndex = 5;
    @Input() stepSubTitle: string;
    @Input() backButtonText = 'Back';
    @Input() backButtonQaId = 'WizardBackButton';
    @Input() unlinkBackButtonFromBrowserActionFlag = false; //Remove at TCA-2738 - FF removal ticket
    @Input() nextButtonText = 'Next';
    @Input() nextButtonQaId = 'WizardNextButton';
    @Input() nextButton2Text = 'SEND TO CANDIDATE';
    @Input() nextButton2QaId = 'WizardNextButton2';
    @Input() isLoading = true;
    @Input() isNextButtonEnabled = true;
    @Input() isNextButtonLoading = false;
    @Input() isNextButton2Visible = false;
    @Input() isNextButton2Enabled = false;
    @Input() isNextButton2Loading = false;
    @Output() previousStepClicked = new EventEmitter();
    @Output() nextStepClicked = new EventEmitter();
    @Output() nextStep2Clicked = new EventEmitter();
    @Output() headerDisplayedContractClicked = new EventEmitter();

    goToPreviousStep(): void {
        this.previousStepClicked.emit();
    }

    goToNextStep(): void {
        this.nextStepClicked.emit();
    }

    goToNextStep2(): void {
        this.nextStep2Clicked.emit();
    }

    gotoContractProfile(): void {
        this.headerDisplayedContractClicked.emit();
    }

    getBackButtonText(): string {
        if (!this.unlinkBackButtonFromBrowserActionFlag) {
            return 'Back';
        }

        const backButtonText = this.backButtonText ?? 'Back';
        const stepInfo = this.stepIndex > 1 ? ` to step ${this.stepIndex - 1}` : '';
        return backButtonText + stepInfo;
    }
}
